import React, { ReactNode } from 'react';
import { useCurrentAccessPolicy } from '../hooks/useCurrentAccessPolicy';
import { AccessPolicyContext } from './AccessPolicyContext';

// -----------------------------------------------------------------------------
interface AccessPolicyProviderProps {
  children: ReactNode;
}

// -----------------------------------------------------------------------------
export const AccessPolicyProvider: React.FC<AccessPolicyProviderProps> = ({
  children,
}) => {
  const accessPolicyData = useCurrentAccessPolicy();

  return (
    <AccessPolicyContext.Provider value={accessPolicyData}>
      {children}
    </AccessPolicyContext.Provider>
  );
};
